/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';

import { ID_SCROLL_TAB_BLOCK } from "../../../constants/uiConfigs";

import config from '../../../share/config';
import treeView from "../../../share/components/vue/TreeView";
import util from '../../../share/util/utils';
import vehicle from '../../../share/util/vehicle';
import loading from '../../../share/components/vue/ProcessingIcon';
import svgIcon from '../../../share/components/vue/SVGIcon';
import alert from '../../../share/alert';
import individualDiagnose from "../../../share/util/individualDiagnose";
import specialFeature from "../../../share/util/specialFeature";
import resourceMap from '../../../share/util/resourceMap';
import { SUPPORTED_FEATURES } from '../individualSelect/inputSpecialKey';
import DiagSystemUtils from '../../../common/nodejs/diagSystemUtils';
import { getNodeSelectId } from "../../../util/treeUtils";
import { PAGE_FROM_GENERAL } from "../../../router/obd";
import {
  createAllDtcTreeData,
  createIndividualTreeData,
  clickObdAllDtcTreeNode,
  clickObdIndividualTreeNode
} from "../../../util/obd/tree";
import { createObdRouteTreeActions } from './obd';
import {
  EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC,
  EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL
} from "../../../util/obd/functions";
import { RouteTreeAction } from "./routeTreeAction";
import { getAbbrSysName } from '../../../share/util/systemName';


/**
 * 特殊機能個別システム診断表示用マップ
 * key: APIから取得した個別診断メニュー構成情報のkey
 * type: 個別診断機能遷移用定義
 * label: 個別診断機能のラベルKey
 */
const SPECIAL_INDIVIDUAL_FUNCTION_MAP = [
  { key: 'diag_code', type: config.SPECIAL_FEATURE_DIAG_CODE, label: 'individual.individual_diagnosis_function_diag_code' },
  { key: 'vehicle_control_history', type: config.SPECIAL_FEATURE_VEHICLE_CONTROL_HISTORY, label: 'individual.individual_diagnosis_function_vehicle_control_history' },
  { key: 'cancel_code', type: config.SPECIAL_FEATURE_CANCEL_CODE, label: 'individual.individual_diagnosis_function_cancel_code' },
  { key: 'data_monitor', type: config.SPECIAL_FEATURE_DATA_MONITOR, label: 'individual.individual_diagnosis_function_data_monitor' },
  { key: 'work_support', type: config.SPECIAL_FEATURE_WORK_SUPPORT, label: 'individual.individual_diagnosis_function_work_support' },
];

/**
 * システム複数診断表示用マップ
 * key: APIから取得した複数診断メニュー構成情報のkey
 * type: 複数診断機能遷移用定義
 * label: 複数診断機能のラベルKey
 */
const MULTI_INDIVIDUAL_FUNCTION_MAP = [
  { key: 'data_monitor', type: config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE, label: 'message.label_menu_multi_data_monitor' },
  { key: 'customize', type: config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE, label: 'message.label_menu_all_customize' }
];

/**
 * 特殊キー入力サポートシステム名変換マップ
 * match: 診断システム名の判定関数
 * convertedSystemName: inputSpecialKey.js の SUPPORTED_FEATURES で使用するシステム名キー
 */
const INPUT_SPECIAL_KEY_SYSTEM_NAME_MAP = [
  { match: DiagSystemUtils.isEyesightByAbbreviationId, convertedSystemName: 'ES' },
  { match: DiagSystemUtils.isAdasEcuByAbbreviationId, convertedSystemName: 'ADAS' }
];

export default {
  name: "informationMain",
  props: {
    relationReproProcessMsg: { type: String, default: '' },
    systemId: { type: String, default: '' }
  },
  data() {
    return {
      // repro機能
      showModalRelation: false,
      processing: false,
      isTreeViewOpen: false,
      isTreeViewShow: true,
      vin: '',
      specMode: '',
      spec: '',
      model: '',
      modelDisplayName: '',
      appliedModel: '',
      reproTreeData: {},
      isPublished: true,
      // 診断機能
      allDtcTreeData: {},
      diagTreeData: {},
      isShowSelectedSystem: true,
      macKeyTreeData: {},
      immobilizerTreeData: {},
      specialFeatureTreeData: {},
      realWorldDataTreeData: {},
      obdAllDtcTreeData: {},
      obdIndividualTreeData: {},
      rprTreePublished: true, //言語変更時用にツリーの公開情報を保持
      multipleTreeData: []
    };
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'home') {
      // 確認画面skipの情報が設定されているかチェック 
      if ('isConfirmSkip' in to.params) {
        if (util.parseBoolean(to.params.isConfirmSkip)) {
          // HOME画面遷移の確認ダイアログ抑止フラグが立っていればOFFにする
          to.params.isConfirmSkip = false;
          next();
          return;
        }
      }
      const messages = this.$t('message.message_vehicle_dtc_confirm_back_home');
      alert.showConfirmation(this, null, messages, () => {
        // OKボタンが押下された場合はstart画面に戻す
        this.clearTableData();
        next();
      });
    } else {
      next();
    }
  },

  watch: {
    viewMode: {
      immediate: true,
      handler(val) {
        this.isTreeViewOpen = this.isTreeViewOpen ? val === config.PROCESS_IDLING : false;
        this.isTreeViewShow = val === config.PROCESS_IDLING;
      }
    },

    language: {
      handler(val) { // eslint-disable-line no-unused-vars
        if (!val) return;

        // 診断・特殊機能ツリーを初期化
        this.diagTreeData = null;
        this.specialFeatureTreeData = null;

        this.$nextTick(() => {
          // ツリー再構築
          this.updateReproTreeView({ isPublished: this.rprTreePublished });
          this.updateAllDtcTreeView();
          this.updateDiagTreeView();
          this.updateMacTreeView();
          this.updateImmobilizerTreeView();
          this.getVehicleModelDisplayName();
          this.updateSpecialFeatureTreeView();
          this.updateRealWorldDataTreeView();
          this.updateObdAllDtcTreeView();
          this.updateObdIndividualTreeView();
          this.updateMultipleTreeView();
          // 選択していたノードを再選択する
          const routeName = this.$router.currentRoute.value.name;
          this.selectedTreeNode(routeName);
        });

      }
    },

    // 診断システム一覧を監視
    allDtcSystems: {
      handler(val) { // eslint-disable-line no-unused-vars
        if (!val) return;
        this.updateAllDtcTreeView();
        this.updateDiagTreeView();
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
      }
    },

    // 特殊機能表示状態の変更を監視し、特殊機能ツリーを再構築する
    displaySpecialFunction: {
      handler(val) { // eslint-disable-line no-unused-vars
        this.updateSpecialFeatureTreeView();
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
      }
    },

    $route: {
      immediate: true,
      /**
       * ページ遷移を監視する
       * @param {object} to 遷移後の情報
       */
      handler: function (to) {
        this.updateAllDtcTreeView();
        this.updateDiagTreeView();
        this.updateSpecialFeatureTreeView();
        this.updateRealWorldDataTreeView();
        this.updateObdAllDtcTreeView();
        this.updateObdIndividualTreeView();
        this.updateMultipleTreeView();
        this.selectedTreeNode(to.name);
      }
    },

    // OBDメニューサポートを監視
    obdMenuSupport: {
      handler(val) { // eslint-disable-line no-unused-vars
        if (!val || Object.keys(val).length === 0) return;
        this.updateObdAllDtcTreeView();
        this.updateObdIndividualTreeView();
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
      },
    },
  },

  components: {
    'system-tree': treeView,
    'processing-view': loading,
    'svg-icon': svgIcon
  },

  methods: {
    ...mapActions('cache', ['cacheSystemTable', 'cacheSystemTree', 'cacheIsTreeViewOpen']),
    ...mapActions('table', ['clearTableData']),
    ...mapActions('auth', ['logout']),

    // ツリービューの表示・非表示を切り替え
    switchTreeDisplay() {
      const noSwitchArr = [
        config.PROCESS_REPRO_PROCESSING,
        config.PROCESS_REPRO_COMPLETED,
        config.PROCESS_REPRO_SUB_FAILED
      ];
      if (!noSwitchArr.includes(this.viewMode)) {
        this.isTreeViewOpen = !this.isTreeViewOpen;
      }
    },

    getCurrentFuncMode() {
      const path = this.$route.path;
      return (path.indexOf('system-table') !== -1) ? config.EXECUE_FUNCTION_TYPE_RPR : config.EXECUE_FUNCTION_TYPE_DIAG;
    },

    setIsSystemHeaderDisplay(arg) {
      this.isShowSelectedSystem = arg;
    },

    // システムツリーを開く
    // eslint-disable-next-line no-unused-vars
    expandTree(item) {
      // noop
    },

    // リプロ機能ツリーから任意のシステムが選択されたときの処理
    clickReproTreeNode(system) {
      this.selectReproEcu(system.data);
      const needStartQueue = !this.isShowSelectedSystem;
      if (this.targetUnit === null || Number(system.data.id) !== this.targetUnit.unitId || !this.isShowSelectedSystem) {
        // リプロ以外から遷移した場合は必ず実行する
        this.isShowSelectedSystem = true;
        this.$refs.informationTabs.clickReproTreeNode(system, needStartQueue);
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    selectReproEcu: function (system) {
      this.reproTreeData.children[0].children.forEach(node => {
        node.isSelected = system?.id === node.id;
      });
    },

    /**
     * 全DTCツリーを選択されたときの処理
     */
    clickAllDtcTreeNode() {
      if (this.$route.name !== 'dtcTable') {
        this.$router.push({ name: 'dtcTable' });
        // 画面上部へのアンカースクロール
        document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
        return;
        // 自画面への遷移の場合、何もしない
      } else {
        return;
      }
    },

    /**
     * 診断機能ツリーから任意のシステムが選択されたときの処理
     * @param {*} node 選択したノード
     */
    clickDiagTreeNode(node) {
      if (node.data.isSystemList) {
        // vehicleのノードが選ばれた場合、システム一覧に遷移
        if (this.$route.name !== 'individualEcuTable') {
          this.$router.push({ name: 'individualEcuTable' });
          // 画面上部へのアンカースクロール
          document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
          return;
          // 自画面への遷移の場合、何もしない
        } else {
          return;
        }
      }

      // システム名ノードが選ばれた場合、該当システムの診断機能一覧に遷移
      const systemId = node.data.systemId;
      if (node.data.isSystem) {
        // 自画面への遷移の場合、何もしない
        if (this.systemId === systemId && this.$route.name === 'individualSelect') {
          return;
        }

        // 同じシステム内の遷移の場合、同システムフラグ = true とする
        const sameSystemFlg = !!(this.systemId === systemId && individualDiagnose.isRouteNameIndividualDiagnose(this.$route.name));

        // 遷移元がシステム一覧かの判定
        if (this.$route.name === 'individualEcuTable') {
          // 遷移元がシステム一覧の場合、診断機能一覧画面に直接遷移する（同じ画面には遷移できないので分岐している）
          this.$router.push({
            name: "individualSelect",
            params: {
              systemId: systemId
            },
            query: {
              sameSystemFlg: sameSystemFlg
            }
          });
        } else {
          // システム一覧画面経由で、診断機能一覧画面に遷移（パンくず生成のため）
          this.$router.push({
            name: 'individualEcuTable',
            query: {
              systemId: systemId,
              sameSystemFlg: sameSystemFlg
            }
          });
        }
        // 画面上部へのアンカースクロール
        document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
        return;
      }

      // 診断機能ノードが選ばれた場合、該当の診断機能画面に遷移
      const individualFuncType = node.data.individualFunctionType;
      // 自画面への遷移の場合、何もしない
      if (this.systemId === systemId && this.$route.name === individualFuncType) {
        return;
      }

      // 同システム遷移判定
      let sameSystemFlg = false;
      if (this.systemId === systemId && this.$route.name === config.INDIVIDUAL_SELECT && (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'sameSystemFlg'))) {
        // 同じシステム且つ、個別診断メニューからの遷移且つ、同システムフラグが存在する場合、同システムフラグを継承する
        sameSystemFlg = this.$route.query.sameSystemFlg;
      } else {
        // 同じシステム内の遷移の場合、同システムフラグ = true とする
        sameSystemFlg = !!(this.systemId === systemId && individualDiagnose.isRouteNameIndividualDiagnose(this.$route.name));
      }

      // 遷移元がシステム一覧かの判定
      if (this.$route.name === 'individualEcuTable') {
        // 遷移元がシステム一覧の場合、診断機能一覧経由で、診断機能画面に遷移（パンくず生成と、同じ画面には遷移できないので分岐している）
        this.$router.push({
          name: 'individualSelect',
          params: {
            systemId: systemId
          },
          query: {
            funcId: individualFuncType,
            sameSystemFlg: sameSystemFlg
          }
        });
      } else {
        // 遷移元が上記以外の場合、システム一覧 ⇒ 診断機能一覧経由で、診断機能画面に遷移（パンくず生成のため）
        this.$router.push({
          name: 'individualEcuTable',
          query: {
            systemId: systemId,
            funcId: individualFuncType,
            sameSystemFlg: sameSystemFlg
          }
        });
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    clickMacKeyTreeNode() {
      this.isShowSelectedSystem = false;
      if (this.$router.currentRoute.value.name !== 'macKey') {
        this.$router.push({ name: 'macKey' });
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    clickImmobilizerTreeNode() {
      this.isShowSelectedSystem = false;
      if (this.$router.currentRoute.value.name !== 'immobilizer') {
        this.$router.push({ name: 'immobilizer' });
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    /**
     * 特殊機能ツリーのノードを選択した時の処理
     * @param node 選択したノード
     */
    clickSpecialFeatureTreeNode(node) {
      // 特殊機能非対応ユーザーの一時表示ツリーは操作不可
      if (this.isTemporarySpecialFeatureTreeMode) {
        // クリックで付与された選択ハイライトを、現在画面に対応する選択状態へ戻す
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
        return;
      }

      if (node.data.isSystemList) {
        // vehicleのノードが選ばれた場合、システム一覧に遷移
        if (this.$route.name !== 'specialFeatureEcuTable') {
          this.$router.push({ name: 'specialFeatureEcuTable' });
          // 画面上部へのアンカースクロール
          document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
          return;
          // 自画面への遷移の場合、何もしない
        } else {
          return;
        }
      }
      // システム名ノードが選ばれた場合、該当システムの特殊機能一覧に遷移
      const systemId = node.data.systemId;
      if (node.data.isSystem) {
        // 自画面への遷移の場合、何もしない
        if (this.systemId === systemId && this.$route.name === 'specialFeatureSelect') {
          return;
        }

        // 同じシステム内の遷移の場合、同システムフラグ = true とする
        const sameSystemFlg = !!(this.systemId === systemId && specialFeature.isRouteNameSpecialFeatureIndividualDiagnose(this.$route.name));

        // 遷移元がシステム一覧かの判定
        if (this.$route.name === 'specialFeatureEcuTable') {
          // 遷移元がシステム一覧の場合、特殊機能一覧画面に直接遷移する（同じ画面には遷移できないので分岐している）
          this.$router.push({
            name: "specialFeatureSelect",
            params: {
              systemId: systemId
            },
            query: {
              sameSystemFlg: sameSystemFlg
            }
          });
        } else {
          // システム一覧画面経由で、特殊機能一覧画面に遷移（パンくず生成のため）
          this.$router.push({
            name: 'specialFeatureEcuTable',
            query: {
              systemId: systemId,
              sameSystemFlg: sameSystemFlg
            }
          });
        }
        // 画面上部へのアンカースクロール
        document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
        return;
      }
      // 特殊機能ノードが選ばれた場合、該当の特殊機能画面に遷移
      const specialFeatureType = node.data.specialFeatureType;
      // 自画面への遷移の場合、何もしない
      if (this.systemId === systemId && this.$route.name === specialFeatureType) {
        return;
      }

      // 同システム遷移判定
      let sameSystemFlg = false;
      if (this.systemId === systemId && this.$route.name === config.SPECIAL_FEATURE_SELECT && (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'sameSystemFlg'))) {
        // 同じシステム且つ、個別診断メニューからの遷移且つ、同システムフラグが存在する場合、同システムフラグを継承する
        sameSystemFlg = this.$route.query.sameSystemFlg;
      } else {
        // 同じシステム内の遷移の場合、同システムフラグ = true とする
        sameSystemFlg = !!(this.systemId === systemId && specialFeature.isRouteNameSpecialFeatureIndividualDiagnose(this.$route.name));
      }

      // 遷移元がシステム一覧かの判定
      if (this.$route.name === 'specialFeatureEcuTable') {
        // 遷移元がシステム一覧の場合、特殊機能一覧経由で、特殊機能画面に遷移（パンくず生成と、同じ画面には遷移できないので分岐している）
        this.$router.push({
          name: 'specialFeatureSelect',
          params: {
            systemId: systemId
          },
          query: {
            funcId: specialFeatureType,
            sameSystemFlg: sameSystemFlg
          }
        });
      } else {
        // 遷移元が上記以外の場合、システム一覧 ⇒ 特殊機能一覧経由で、特殊機能画面に遷移（パンくず生成のため）
        this.$router.push({
          name: 'specialFeatureEcuTable',
          query: {
            systemId: systemId,
            funcId: specialFeatureType,
            sameSystemFlg: sameSystemFlg
          }
        });
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },
    clickRealWorldDataTreeNode() {
      this.isShowSelectedSystem = false;
      if (this.$router.currentRoute.value.name !== config.REAL_WORLD_DATA_SELECT) {
        this.$router.push({ name: config.REAL_WORLD_DATA_SELECT });
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },
    clickObdAllDtcNode() {
      // OBD全DTCツリーノードクリック処理
      const clickObdAllDtcLogic = () => {
        // ツリーを開き状態にする
        this.cacheIsTreeViewOpen(true);
        // OBD全DTCのノードクリック処理
        clickObdAllDtcTreeNode(this, PAGE_FROM_GENERAL);
        // 画面上部へのアンカースクロール
        document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
      };

      // OBDシステム情報が存在しない場合、確認ダイアログを表示
      if (!this.obdSystems || !this.obdSystems.length) {
        // 選択していたノードを再選択する
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
        // 確認ダイアログ
        alert.showConfirmation(
          this,
          null,
          this.$t('fixed_resource.label_confirm_start_connection_obd_vehicle'),
          // 続行時のコールバック
          () => {
            // OBD全DTCツリーノードクリック処理
            clickObdAllDtcLogic();
          }
        );
      } else {
        // OBD全DTCツリーノードクリック処理
        clickObdAllDtcLogic();
      }
    },
    clickObdIndividualNode(node) {
      // OBD個別診断ツリーノードクリック処理
      const clickObdIndividualLogic = () => {
        // ツリーを開き状態にする
        this.cacheIsTreeViewOpen(true);
        // OBD個別診断のノードクリック処理
        clickObdIndividualTreeNode(this, PAGE_FROM_GENERAL, node);
        // 画面上部へのアンカースクロール
        document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
      };

      // OBDシステム情報が存在しない場合、確認ダイアログを表示
      if (!this.obdSystems || !this.obdSystems.length) {
        // 選択していたノードを再選択する
        const routeName = this.$router.currentRoute.value.name;
        this.selectedTreeNode(routeName);
        // 確認ダイアログ
        alert.showConfirmation(
          this,
          null,
          this.$t('fixed_resource.label_confirm_start_connection_obd_vehicle'),
          // 続行時のコールバック
          () => {
            // OBD個別診断ツリーノードクリック処理
            clickObdIndividualLogic();
          }
        );
      } else {
        // OBD個別診断ツリーノードクリック処理
        clickObdIndividualLogic();
      }
    },
    clickMultipleTreeNode(system) {
      this.isShowSelectedSystem = false;
      if (system.data.functionId === "data_monitor") {
        // マルチデータモニタ選択時
        if (this.$router.currentRoute.value.name === config.EXECUE_FUNCTION_TYPE_MULTIPLE) {
          // 現在画面が複数診断メニューの場合、システム一覧画面へ遷移
          this.$router.push({
            name: config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE,
            params: {
              functionName: system.data.functionId
            }
          });
        } else if (this.$router.currentRoute.value.name !== config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE) {
          // 複数診断メニュー経由で、システム一覧画面に遷移（パンくず生成のため）
          this.$router.push({
            name: config.EXECUE_FUNCTION_TYPE_MULTIPLE,
            query: {
              functionId: system.data.functionId
            }
          });
        }
      } else {
        if (this.$router.currentRoute.value.name === config.EXECUE_FUNCTION_TYPE_MULTIPLE) {
          // 現在画面が複数診断メニュー画面
          this.$router.push({
            name: system.data.functionType,
          });
        } else if (this.$router.currentRoute.value.name !== system.data.functionType) {
          // 現在画面と遷移先が同一でない
          this.$router.push({
            name: config.EXECUE_FUNCTION_TYPE_MULTIPLE,
            query: {
              functionId: system.data.functionId
            }
          });
        }
      }
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    /**
     * ツリービューの表示・非表示を切り換える。
     * @param {boolean} isVisible 表示: true, 非表示: false
     * @returns
     */
    visibleTreeView: function (isVisible) {
      this.isTreeViewShow = isVisible;
    },

    // システム一覧からリプロ機能向けツリービューを生成
    updateReproTreeView: function ({ isPublished, tables = this.reproSystems }) {
      const pblTbl = tables ? tables.published : [];
      const unpblTbl = tables ? tables.unpublished : [];
      const unitId = this.targetUnit && this.targetUnit.unitId ? this.targetUnit.unitId : '';
      const unitNames = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      // 言語変更時用にツリーの公開情報を更新
      this.rprTreePublished = isPublished;
      // 同じECUでも公開・非公開でシステムIDが違う場合があるので、公開・非公開ごとで表示させるツリーを作成
      const rprTreeTbl = [];
      if (isPublished) {
        // 公開システムのツリーを作成
        pblTbl.forEach((data) => {
          rprTreeTbl.push({
            name: unitNames[data.id] || '',
            id: data.id,
            selectId: util.getUniqueIdStr(),
            isSelected: unitId === data.id
          });
        });
      } else {
        // 非公開システムのツリーを作成
        unpblTbl.forEach((data) => {
          rprTreeTbl.push({
            name: unitNames[data.id] || '',
            id: data.id,
            selectId: util.getUniqueIdStr(),
            isSelected: unitId === data.id
          });
        });
      }
      this.reproTreeData = {
        name: 'message.label_function_menu_reprogramming',
        selectId: util.getUniqueIdStr(),
        isSelected: false,
        noSelected: true,
        useResource: true,
        children: [
          {
            name: 'message.header_vehicle_system_tree_Modules',
            selectId: util.getUniqueIdStr(),
            isSelected: false,
            noSelected: true,
            useResource: true,
            children: util.sortItems(rprTreeTbl, 'name', config.ASC) // あいうえお順（アルファベット順）にソート
          }
        ]
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_RPR, tbl: this.reproTreeData });
    },

    // 全DTCツリービューを生成
    updateAllDtcTreeView: function () {
      this.allDtcTreeData = {
        name: 'message.label_function_menu_all_dtc',
        selectId: `all_dtc`,
        isTitle: true,
        isSelected: false,
        noSelected: false,
        useResource: true,
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_DIAG, tbl: this.allDtcTreeData });
    },

    // システム一覧から診断機能向けツリービューを生成
    updateDiagTreeView: function () {
      this.diagTreeData = {
        name: 'individual.label_menu_individual_diagnosis',
        selectId: `individual_vehicle`,
        isSystemList: true,
        isSelected: false,
        noSelected: false,
        useResource: true,
        children: this.makeDtcUnitedItems()
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE, tbl: this.diagTreeData });
    },

    updateMacTreeView: function () {
      this.macKeyTreeData = {
        name: 'mac.label_mac_key',
        selectId: util.getUniqueIdStr(),
        isSelected: false,
        noSelected: false,
        useResource: true,
        children: []
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_MACKKEY, tbl: this.macKeyTreeData });
    },
    updateImmobilizerTreeView: async function () {

      this.immobilizerTreeData = {
        name: 'imb.common_immobilizer',
        selectId: util.getUniqueIdStr(),
        isSelected: false,
        noSelected: false,
        useResource: true,
        children: []
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_IMMOBILIZER, tbl: this.immobilizerTreeData });
    },

    /**
     * 特殊機能のツリービューを生成
     */
    updateSpecialFeatureTreeView: async function () {
      this.specialFeatureTreeData = {
        name: 'message.label_function_menu_special_feature',
        selectId: `sp_vehicle`,
        isSystemList: true,
        isSelected: false,
        noSelected: false,
        useResource: true,
        children: []
      };

      if (!this.individualMenus || !this.individualMenus.menu_list) {
        return;
      }
      // メニューサポートからシステムリストを取得
      const groupArray = this.individualMenus.menu_list.map((item) => item.system_name);
      const menuList = this.individualMenus.menu_list;
      const temporarySpecialFeatureTypes = this.displaySpecialFunction.map(feature => feature.type);

      let individual_index = 0;
      for (let index = 0; index < groupArray.length; index++) {
        // システム対象IDからname情報を取得
        const nameId = resourceMap.getResourceKeyForDiagSystem(groupArray[index]);
        const temporaryVisibleTypes = this.getTemporarySpecialFeatureTypes(groupArray[index]);
        // 全機能ボタンの中から個別診断メニューでサポートされているもののみ残す
        const individual_children = SPECIAL_INDIVIDUAL_FUNCTION_MAP.filter(
          (data) => {
            const targetMenu = menuList.find(menu => menu.system_name === groupArray[index]);
            if (!targetMenu || !targetMenu.menu_display_config) {
              return false;
            }

            // 特殊機能非対応ユーザーの一時表示状態の場合、「*〇〇」が表示される特殊機能のみ表示対象にする
            if (this.isTemporarySpecialFeatureTreeMode) {
              // 特殊機能一時表示モードで表示可能な特殊機能に含まれていない場合は非表示にする
              if (!temporaryVisibleTypes.includes(data.type) || !temporarySpecialFeatureTypes.includes(data.type)) {
                return false;
              }
            }

            // 特殊機能のダイアグコード、キャンセルコードの場合はspecial_feature_menu_display_configを確認する
            if (data.type === config.SPECIAL_FEATURE_DIAG_CODE || data.type === config.SPECIAL_FEATURE_CANCEL_CODE) {
              if (!targetMenu.special_feature_menu_display_config) {
                return false;
              }
              return Object.keys(targetMenu.special_feature_menu_display_config).some(individualKey =>
                // special_feature_menu_display_configに対象の個別診断機能のkeyが存在し、値がtrueの場合、個別診断のツリーを作成する
                individualKey === data.key &&
                targetMenu.special_feature_menu_display_config[individualKey]
              );
            }

            return Object.keys(targetMenu.menu_display_config).some(individualKey =>
              // menu_display_configに対象の個別診断機能のkeyが存在し、値がtrueの場合、個別診断のツリーを作成する
              individualKey === data.key &&
              targetMenu.menu_display_config[individualKey]
            );
          }
        ).map(item => {
          // selectIdがシステム間で重複しないよう連番を設定（ランダム生成だと低確率で重複する可能性があるため）
          individual_index++;
          // ツリー用のオブジェクトに変換する
          return {
            name: item.label,
            selectId: `sp_${individual_index}`,
            useResource: true,
            isSystem: false,
            isSelected: false,
            noSelected: false,
            functionType: config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE,
            systemId: groupArray[index],
            specialFeatureType: item.type
          };
        });

        if (individual_children.length < 1) {
          continue;
        }

        const menuChild = {
          name: nameId,
          i18nName: this.$t(nameId),
          selectId: `sp_ecu_${index}`,
          isSystem: true,
          systemId: groupArray[index],
          isSelected: false,
          useResource: true,
          noSelected: false,
          children: individual_children
        };
        this.specialFeatureTreeData.children.push(menuChild);
      }
      // あいうえお順（アルファベット順）にソート
      this.specialFeatureTreeData.children = util.sortItems(this.specialFeatureTreeData.children, 'i18nName', config.ASC);
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE, tbl: this.specialFeatureTreeData });
    },

    /**
     * 特殊機能一時表示モードで、システムごとに表示可能な特殊機能タイプを返す
     * @param {string} systemName システム名
     * @returns {Array<string>} 表示可能な特殊機能タイプ
     */
    getTemporarySpecialFeatureTypes(systemName) {
      const convertedSystemName = INPUT_SPECIAL_KEY_SYSTEM_NAME_MAP.find(({ match }) => match(getAbbrSysName(systemName)))?.convertedSystemName;
      if (!convertedSystemName) {
        return [];
      }
      return SUPPORTED_FEATURES.find(item => item[convertedSystemName] !== undefined)?.[convertedSystemName] || [];
    },

    /**
         * 個車情報取得のツリービューを生成
         */
    updateRealWorldDataTreeView: async function () {
      this.realWorldDataTreeData = {
        name: 'message.label_function_menu_vehicle_information',
        selectId: util.getUniqueIdStr(),
        isSelected: false,
        noSelected: false,
        useResource: true,
        children: []
      };
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA, tbl: this.realWorldDataTreeData });
    },

    /**
     * OBD全DTCのツリービューを生成
     */
    updateObdAllDtcTreeView: async function () {
      this.obdAllDtcTreeData = createAllDtcTreeData(this);
      this.cacheSystemTree({ type: EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC, tbl: this.obdAllDtcTreeData });
    },

    /**
     * OBD個別診断のツリービューを生成
     */
    updateObdIndividualTreeView: async function () {
      this.obdIndividualTreeData = createIndividualTreeData(this, this.obdMenuSupport, this.obdSystems);
      this.cacheSystemTree({ type: EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL, tbl: this.obdIndividualTreeData });
    },

    /**
     * システム複数診断のツリービューを生成
    */
    updateMultipleTreeView: async function () {
      let result = {};
      let allCstSystemList = [];

      this.multipleTreeData = MULTI_INDIVIDUAL_FUNCTION_MAP.reduce((arr, obj) => {
        if (obj.type === config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE) {
          if (!this.multipleMenuList || !this.multipleMenuList.menu_list) {
            return arr;
          }

          allCstSystemList = this.multipleMenuList.menu_list.reduce((acc, menu) => {
            if (menu.menu_display_config.customize) acc.push(menu.system_name);
            return acc;
          }, []);
        }

        if (obj.type !== config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE ||
          (obj.type === config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE && allCstSystemList.length >= 1)) {
          // 全カスタマイズは対象のシステムリストが0件の時ツリーも表示しない
          result = {
            functionId: obj.key,
            functionType: obj.type,
            name: obj.label,
            selectId: util.getUniqueIdStr(),
            isSelected: false,
            noSelected: false,
            useResource: true,
            children: []
          };
          this.cacheSystemTree({ type: obj.type, tbl: result });
          arr.push(result);
        }
        return arr;
      }, []);
    },

    makeDtcUnitedItems() {
      const systemList = [];
      if (!this.individualMenus || !this.individualMenus.menu_list) return systemList;
      // メニューサポートからシステムリストを取得
      const groupArray = this.individualMenus.menu_list.map((item) => item.system_name);
      const menuList = this.individualMenus.menu_list;
      let individual_index = 0;
      for (let index = 0; index < groupArray.length; index++) {
        // システム対象IDからname情報を取得
        const nameId = resourceMap.getResourceKeyForDiagSystem(groupArray[index]);

        // DTC/制御作動履歴 統合メニュー判定
        const targetMenu = menuList.find(menu => menu.system_name === groupArray[index]);
        const isCombined = individualDiagnose.areDiagAndVchEnabled(targetMenu);

        const children = individualDiagnose.filterIndividualFunctionMap(targetMenu, isCombined).map(item => {
          // selectIdがシステム間で重複しないよう連番を設定（ランダム生成だと低確率で重複する可能性があるため）
          individual_index++;
          // ツリー用のオブジェクトに変換する
          return {
            name: item.label,
            selectId: individual_index,
            useResource: true,
            isSystem: false,
            isSelected: false,
            noSelected: false,
            functionType: config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE,
            systemId: groupArray[index],
            individualFunctionType: item.type,
          };
        });
       
        // 統合メニューは先頭に追加
        if (isCombined) {
          individual_index++;
          children.unshift({
            name: 'individual.individual_diagnosis_function_dtc_with_vch',
            selectId: individual_index,
            useResource: true,
            isSystem: false,
            isSelected: false,
            noSelected: false,
            functionType: config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE,
            systemId: groupArray[index],
            individualFunctionType: config.INDIVIDUAL_FUNCTION_DTC_VCH,
          });
        }

        systemList.push({
          name: nameId,
          i18nName: this.$t(nameId),
          selectId: `individual_ecu_${index}`,
          isSystem: true,
          systemId: groupArray[index],
          isSelected: false,
          useResource: true,
          noSelected: false,
          children: children
        });
      }
      // あいうえお順（アルファベット順）にソート
      return util.sortItems(systemList, 'i18nName', config.ASC);
    },

    activateInquiredNode: function (unitId, isPublished) {
      const tree = this.reproTreeData.children[0].children;
      const pblTbl = this.reproSystems ? this.reproSystems.published : [];
      const unpblTbl = this.reproSystems ? this.reproSystems.unpublished : [];
      const pblIndex = pblTbl.findIndex(node => Number(node.id) === unitId);
      const unpblIndex = unpblTbl.findIndex(node => Number(node.id) === unitId);
      for (const i in tree) {
        // 個別 Inquiry を実行した公開ファイルのノードだけ選択状態にする
        if (pblIndex !== -1) {
          if (tree[i].id === pblTbl[pblIndex].id) {
            if (isPublished)
              this.reproTreeData.children[0].children[i].isSelected = true;
          } else {
            this.reproTreeData.children[0].children[i].isSelected = false;
          }
        }
        // 個別 Inquiry を実行した非公開ファイルのノードだけ選択状態にする
        if (unpblIndex !== -1) {
          if (tree[i].id === unpblTbl[unpblIndex].id) {
            if (!isPublished)
              this.reproTreeData.children[0].children[i].isSelected = true;
          } else {
            this.reproTreeData.children[0].children[i].isSelected = false;
          }
        }
      }
    },

    /**
     * 指定された funcType のツリーノードを全て選択解除する
     * @param {string} funcType ツリーノードの種類
     */
    changeUnselectedAllNode: function (funcType) {
      if (funcType === config.EXECUE_FUNCTION_TYPE_RPR) this.reproTreeData = util.relaseTreeSelected(this.reproTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_DIAG) this.allDtcTreeData = util.relaseTreeSelected(this.allDtcTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_MACKKEY) this.macKeyTreeData = util.relaseTreeSelected(this.macKeyTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_IMMOBILIZER) this.immobilizerTreeData = util.relaseTreeSelected(this.immobilizerTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE) this.specialFeatureTreeData = util.relaseTreeSelected(this.specialFeatureTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE) this.diagTreeData = util.relaseTreeSelected(this.diagTreeData);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA);
      if (funcType === EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC) this.obdAllDtcTreeData = util.relaseTreeSelected(this.obdAllDtcTreeData);
      if (funcType === EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL) this.obdIndividualTreeData = util.relaseTreeSelected(this.obdIndividualTreeData);
      if (funcType === config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE || funcType === config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE) {
        const index = this.multipleTreeData.findIndex(ele => (ele.functionType === funcType));
        if (index !== -1) this.multipleTreeData[index] = util.relaseTreeSelected(this.multipleTreeData[index]);
      }
    },

    /**
     * 指定された funcType 「以外」のツリーノードを全て選択解除する
     * funcType 未指定の場合は全てのツリーノードを選択解除する
     * @param {string} funcType ツリーノードの種類
     */
    changeUnselectedOtherTreeNode: function (funcType) {
      if (funcType !== config.EXECUE_FUNCTION_TYPE_RPR) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_RPR);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_DIAG) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_DIAG);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_MACKKEY) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_MACKKEY);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_IMMOBILIZER) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_IMMOBILIZER);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA);
      if (funcType !== EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC) this.changeUnselectedAllNode(EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC);
      if (funcType !== EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL) this.changeUnselectedAllNode(EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE);
      if (funcType !== config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE) this.changeUnselectedAllNode(config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE);
    },

    /**
     * conditionCallback の条件に合うノードのみを選択状態にし、それ以外を全て選択解除にする
     * @param {string} funcType 選択状態にするツリーノード（それ以外のツリーノードは全て選択解除にする） ※現状は config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE, config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE のみ対応
     * @param {function} conditionCallback 条件判断を行うコールバック function （引数として、ノードが渡ってくるので boolean で返すこと）
     */
    changeSelectedNode: function (funcType, conditionCallback) {
      // 指定された funcType 以外のツリーノードを全て選択解除する
      this.changeUnselectedOtherTreeNode(funcType);
      // 全DTCツリーの場合
      if (funcType === config.EXECUE_FUNCTION_TYPE_DIAG) {
        // 自動的に選択中のノードまでツリーをオープン＆選択状態にさせる
        const selectId = getNodeSelectId(this.allDtcTreeData, conditionCallback);
        this.$refs.allDtcTreeView?.setOpenAndSelectTreeNode(selectId, true);
      }
      // 診断ツリーの場合
      if (funcType === config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE) {
        // 自動的に選択中のノードまでツリーをオープン＆選択状態にさせる
        const selectId = getNodeSelectId(this.diagTreeData, conditionCallback);
        this.$refs.treeView?.setOpenAndSelectTreeNode(selectId, true);
      }
      // 特殊機能ツリーの場合
      if (funcType === config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE) {
        // 自動的に選択中のノードまでツリーをオープン＆選択状態にさせる   
        const selectId = getNodeSelectId(this.specialFeatureTreeData, conditionCallback);
        this.$refs.specialTreeView?.setOpenAndSelectTreeNode(selectId, true);
      }
      // OBD全DTCツリーの場合
      if (funcType === EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC) {
        // 自動的に選択中のノードまでツリーをオープン＆選択状態にさせる
        const selectId = getNodeSelectId(this.obdAllDtcTreeData, conditionCallback);
        this.$refs.obdAllDtcTreeView?.setOpenAndSelectTreeNode(selectId, true);
      }
      // OBD個別診断ツリーの場合
      if (funcType === EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL) {
        // 自動的に選択中のノードまでツリーをオープン＆選択状態にさせる
        const selectId = getNodeSelectId(this.obdIndividualTreeData, conditionCallback);
        this.$refs.obdIndividualTreeView?.setOpenAndSelectTreeNode(selectId, true);
      }
    },

    getVehicleModelDisplayName: function () {
      if (this.model) {
        const vehicleModel = vehicle.getVehicleModelDisplayNames(this.vehicleModelDisplayNameList, this.language);
        this.modelDisplayName = vehicleModel[this.model] || '-';
      } else {
        this.modelDisplayName = '-';
      }
    },


    /**
     * routeNameを元に、ツリーの選択状態を設定する関数
     * @param {string} currentRouteName 現在の routeName
     */
    // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
    /* eslint-disable complexity */
    selectedTreeNode: function (currentRouteName) {
      switch (currentRouteName) {
        case 'suSystemTable':
        case 'systemTable':
        case 'systemInformation':
        case 'systemFileTable':
          this.changeUnselectedOtherTreeNode(config.EXECUE_FUNCTION_TYPE_RPR);
          break;
        case 'dtcTable':
          // 全DTCでは画面上部にシステム名表示を行わない
          this.isShowSelectedSystem = false;
          this.$nextTick(() => {
            this.changeSelectedNode(
              config.EXECUE_FUNCTION_TYPE_DIAG,
              node => {
                // routeNameが全DTCの場合
                if (currentRouteName === 'dtcTable' && node.isTitle) {
                  return true;
                }
                return false;
              }
            );
          });
          break;
        case 'individualEcuTable':
        case 'individualSelect':
        case config.INDIVIDUAL_FUNCTION_DIAG_CODE:
        case config.INDIVIDUAL_FUNCTION_CANCEL_CODE:
        case config.INDIVIDUAL_FUNCTION_DATA_MONITOR:
        case config.INDIVIDUAL_FUNCTION_VEHICLE_CONTROL_HISTORY:
        case config.INDIVIDUAL_FUNCTION_DTC_VCH:
        case config.INDIVIDUAL_FUNCTION_ACTIVE_TEST:
        case config.INDIVIDUAL_FUNCTION_WORK_SUPPORT:
        case config.INDIVIDUAL_FUNCTION_CUSTOMIZE:
          this.$nextTick(() => {
            // 画面上部にシステム名表示を行わない
            this.isShowSelectedSystem = false;
            // ツリーの選択状態を設定
            this.changeSelectedNode(
              config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE,
              node => {
                const systemId = this.$route.params && this.systemId;
                // routeNameがシステム一覧で、システム一覧のノードの場合
                if (currentRouteName === 'individualEcuTable' && node.isSystemList) {
                  return true;
                }
                // routeNameとノードが特殊機能一覧で、params.systemIdとノードに設定されたsystemIdが等しい場合
                if (currentRouteName === 'individualSelect' && node.systemId === systemId && node.isSystem) {
                  return true;
                }
                // 特殊機能で、params.systemIdとノードに設定されたsystemIdが等しい場合
                if (node.individualFunctionType === currentRouteName && node.systemId === systemId) {
                  return true;
                }
                return false;
              }
            );
          });
          break;
        case 'macKey':
          this.$nextTick(() => {
            this.changeSelectedNode(config.EXECUE_FUNCTION_TYPE_MACKKEY);
            this.macKeyTreeData.isSelected = true;
          });
          break;
        case 'immobilizer':
          this.$nextTick(() => {
            this.changeSelectedNode(config.EXECUE_FUNCTION_TYPE_IMMOBILIZER);
            this.immobilizerTreeData.isSelected = true;
          });
          break;
        case 'specialFeatureEcuTable':
        case 'specialFeatureSelect':
        case config.SPECIAL_FEATURE_WORK_SUPPORT:
        case config.SPECIAL_FEATURE_DIAG_CODE:
        case config.SPECIAL_FEATURE_CANCEL_CODE:
        case config.SPECIAL_FEATURE_DATA_MONITOR:
        case config.SPECIAL_FEATURE_VEHICLE_CONTROL_HISTORY:
          this.$nextTick(() => {
            // 画面上部にシステム名表示を行わない
            this.isShowSelectedSystem = false;
            // ツリーの選択状態を設定
            this.changeSelectedNode(
              config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE,
              node => {
                const systemId = this.$route.params && this.systemId;
                // routeNameがシステム一覧で、システム一覧のノードの場合
                if (currentRouteName === 'specialFeatureEcuTable' && node.isSystemList) {
                  return true;
                }
                // routeNameとノードが特殊機能一覧で、params.systemIdとノードに設定されたsystemIdが等しい場合
                if (currentRouteName === 'specialFeatureSelect' && node.systemId === systemId && node.isSystem) {
                  return true;
                }
                // 特殊機能で、params.systemIdとノードに設定されたsystemIdが等しい場合
                if (node.specialFeatureType === currentRouteName && node.systemId === systemId) {
                  return true;
                }
                return false;
              }
            );
          });
          break;
        case config.REAL_WORLD_DATA_SELECT:
          this.$nextTick(() => {
            this.changeSelectedNode(config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA);
            this.realWorldDataTreeData.isSelected = true;
          });
          break;
        default:
          // eslint で条件分岐が多いと指摘が出ているため、今後 case の追加を避けること
          // RouteTreeAction クラスを増やす等で対応すること（既存のものを修正する際も置き換えを検討すること）
          this.executeRouteTreeAction(currentRouteName);
          break;
      }
    },

    /**
     * 現在のページを元にツリー操作処理を実行する
     * @param {string} currentRouteName 現在の routeName
     */
    executeRouteTreeAction: function (currentRouteName) {
      // 画面遷移を検知してツリー操作を行う処理を追加する場合、ここに RouteTreeAction クラスをリストに追加する
      const routeTreeActions = [
        // OBD
        ...createObdRouteTreeActions(this, this.changeSelectedNode),

        // システム複数診断
        new RouteTreeAction(
          (currentRouteName) =>
            currentRouteName === 'multipleEcuTable',
          () => {
            this.changeUnselectedOtherTreeNode(config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE);
            this.multipleTreeData.find(ele => ele.functionId === "data_monitor").isSelected = true;
          }
        ),

        // システム複数診断
        new RouteTreeAction(
          (currentRouteName) =>
            currentRouteName === 'allCustomize',
          () => {
            this.changeUnselectedOtherTreeNode(config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE);
            this.multipleTreeData.find(ele => ele.functionId === "customize").isSelected = true;
          }
        ),
      ];

      // judgeRoute で true が返ってきた場合は、その treeAction を実行する。
      const treeAction = routeTreeActions.find(routeAction => !!routeAction.judgeRoute(currentRouteName))?.treeAction;
      if (treeAction) {
        this.$nextTick(() => {
          // 画面上部にシステム名表示を行わない
          this.isShowSelectedSystem = false;
          treeAction(currentRouteName);
        });
      }
    },
  },

  computed: {
    ...mapState({
      resources: state => state.masterResources.targetUnits,
      vehicleModelDisplayNameList: state => state.masterResources.vehicleModelDisplayNameList,
      selectedSystem(state) {
        if (state.targetUnit.unitInfo) {
          const unitInfo = state.targetUnit.unitInfo;
          const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(state.masterResources.targetUnits, state.systems.language);
          let unitName = '';
          if (unitInfo.type2DisplayUnitId) {
            unitName = targetUnitDisplayData[unitInfo.type2DisplayUnitId] || '';
          } else {
            const cachedTargetInfo = state.userProperty.userCache[config.USER_CACHE_REPRO_TARGET_INFO];
            const isSuFlow = state.cache.vehicleInfo?.vehicle?.is_su_flow ?? cachedTargetInfo?.vehicle?.is_su_flow;
            const commonDisplayUnitId = this.$route.name === 'systemFileTable' && isSuFlow
              ? util.getType2DisplayUnitId(unitInfo.unitId, state.masterResources.targetUnits)
              : null;
            unitName = targetUnitDisplayData[commonDisplayUnitId || unitInfo.unitId] || '';
          }
          if (unitName) {
            return `- ${unitName}`;
          }
        }
        return '';
      },
      vehicleInfo: state => state.cache.vehicleInfo,
      cachedTree: state => state.cache.systemTree,
      viewMode: state => state.app.viewProcessMode,
      watcher: state => state.vehicle.watcher,
      targetUnit: state => state.targetUnit.unitInfo,
      language: state => state.systems.language,
      region: state => state.userProperty.userInfo.region,
      isTechnicalHq: state => state.userProperty.userInfo.isTechnicalHq,
      reproSystems: state => state.cache.systemTable,
      allDtcSystems: state => state.table.allDtcSystems,
      isTestMode: state => state.netAppConnector.isTestMode,
      hasAllDtcSystems(state) {
        // DTCテーブル情報のDATAが空配列の場合、全DTCタブ非表示
        if (state.table.allDtcSystems === null || state.table.allDtcSystems.data.length === 0) {
          return false;
        }
        return true;
      },
      hasIndividualMenus(state) {
        // 個別診断の機能を利用できるシステムがあれば個別診断ツリーを表示
        if (state.vehicle.individualMenus === null ||
          state.vehicle.individualMenus.menu_list.length === 0 ||
          !state.vehicle.individualMenus.menu_list.some((system) => system.menu_display_config)) {
          return false;
        }
        return state.vehicle.individualMenus.menu_list.some((system) =>
          Object.values(system.menu_display_config).some((visibleMenu) => !!visibleMenu));
      },
      isDisplayTreeView: state => !state.netAppConnector.isTestMode,
      displayReproTypeMode: state => state.cache.showDisplayVehicle,
      netAppId: state => state.netAppConnector.pairingAppId,
      menuList: state => state.immobilizer.menuList,
      isDisplayImbTreeView: state => state.immobilizer.isImbSupport,
      isDisplayMacTreeView: state => state.macKey.isMacSupport,
      isDisplayReproTreeView: state => state.table.isReproSupport,
      isDisplaySpecialFeature: state => state.userProperty.isSpecialSupport,
      displaySpecialFunction: state => state.vehicle.displaySpecialFunction,
      individualMenus: state => state.vehicle.individualMenus,
      multipleMenuList: state => state.vehicle.multipleMenus,
      isDisplayRealWorldDataTreeView: state => state.vehicle.isRealWorldDataSupport,
      // Ph4メニューアクティベート可否
      isDisplayPh4MenusCanBeActivated: state => state.vehicle.vehicleInfo?.vehicle?.vin?.ph4_menus_can_be_activated,
      // 機能の利用可否
      isReproVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_RPR],
      isAllDtcVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_DIAG],
      isIndividualVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG],
      isImbVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_IMMOBILIZER],
      isMackeyVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_MACKKEY],
      isObdVisible: state => state.userProperty.functionAvailability[config.FUNCTION_TYPE_OBD],
      isSpecialFeatureSupport: state => !state.netAppConnector.isTestMode,
      isDisplayRealWorldData: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA],
      obdMenuSupport: (state) => state.obd.menuSupport,
      obdSystems: (state) => state.obd.systems,
      isCacheTreeViewOpen: (state) => state.cache.isTreeViewOpen,
      isMultipleVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG],
      hasMultipleMenus(state) {
        // 個別診断の機能を利用できるシステムがあれば複数診断ツリーを表示
        // トレーニングモード時非表示
        if (state.vehicle.multipleMenus === null ||
          state.vehicle.multipleMenus.menu_list.length === 0 ||
          !state.vehicle.multipleMenus.menu_list.some((system) => system.menu_display_config) ||
          state.netAppConnector.isTestMode) {
          return false;
        }
        return state.vehicle.multipleMenus.menu_list.some((system) =>
          Object.values(system.menu_display_config).some((visibleMenu) => !!visibleMenu));
      },
    }),

    /**
     * 特殊機能非対応ユーザー向けの一時ツリー表示モードか
     * @returns {boolean} true: 特殊機能非対応ユーザー向けの一時表示モード
     */
    isTemporarySpecialFeatureTreeMode() {
      return !this.isDisplaySpecialFeature && this.displaySpecialFunction.length > 0;
    },

    /**
     * 特殊機能ツリーの表示可否
     * @returns {boolean} true: 特殊機能ツリーを表示する
     */
    isSpecialFeatureTreeVisible() {
      // 一時表示モード時でツリーに子要素がない場合は表示しない
      if (this.isTemporarySpecialFeatureTreeMode &&
        (!this.specialFeatureTreeData || !this.specialFeatureTreeData.children || this.specialFeatureTreeData.children.length === 0)) {
        return false;
      }
      return (this.isDisplaySpecialFeature || this.isTemporarySpecialFeatureTreeMode)
        && this.isSpecialFeatureSupport
        && this.isDisplayPh4MenusCanBeActivated;
    },

    /**
     * 画面上部判定用 HTML の ID を取得する。
     * @returns {string} ID
     */
    idScrollTabBlock: () => ID_SCROLL_TAB_BLOCK,
  },

  async created() {

    // メンバ変数に値を格納
    const vcl = this.vehicleInfo.vehicle;
    this.specMode = vcl.vin.type === 'vin' ? 'abroad' : 'domestic';
    this.vin = vcl.vin.vin;
    switch (vcl.vin.type) {
      case config.VEHICLEINFO_TYPE_VIN:
        this.spec = vcl.spec.model_year ? vcl.spec.model_year : '-';
        break;
      case config.VEHICLEINFO_TYPE_CHASSISNUMBER:
        this.spec = vcl.spec.classification ? vcl.spec.classification : '-';
        break;
      case config.VEHICLEINFO_TYPE_UN_KNOWN:
        this.spec = '-'; break;
      default:
        this.spec = '-'; break;
    }
    this.appliedModel = (vcl.vin.type === config.VEHICLEINFO_TYPE_CHASSISNUMBER && vcl.vin.applied_model) ? vcl.vin.applied_model : '-';
    this.model = vcl.spec.model || null;
    this.getVehicleModelDisplayName();

    // パスワード変更または単位設定画面から戻った場合はキャッシュ情報を使用する。
    if (util.isFromSettingsPage(util.getPreviousDisplayName(this.$route))) {
      // キャッシュ済みのツリーを設定
      // HACK: 機能が増えるごとに記述量が増加するため、ループ処理での記述に変更する。
      this.reproTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_RPR]);
      this.allDtcTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_DIAG]);
      this.diagTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE]);
      this.macKeyTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_MACKKEY]);
      this.immobilizerTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_IMMOBILIZER]);
      this.specialFeatureTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE]);
      this.realWorldDataTreeData = util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA]);
      this.obdAllDtcTreeData = util.relaseTreeSelected(this.cachedTree[EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC]);
      this.obdIndividualTreeData = util.relaseTreeSelected(this.cachedTree[EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL]);
      this.multipleTreeData = [util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE])];
      // 全カスタマイズは対象のシステムリストが0件の時ツリーも表示しない
      if (this.multipleMenuList && this.multipleMenuList.menu_list && this.multipleMenuList.menu_list.reduce((acc, menu) => {
        if (menu.menu_display_config.customize) acc.push(menu.system_name);
        return acc;
      }, []).length > 0) {
        this.multipleTreeData.push(util.relaseTreeSelected(this.cachedTree[config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE]));
      }
    } else {
      // ツリーのキャッシュは初期化
      // HACK: 機能が増えるごとに記述量が増加するため、ループ処理での記述に変更する。
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_RPR, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_DIAG, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_MACKKEY, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_IMMOBILIZER, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_SPECIAL_FEATURE_ECU_TABLE, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_ECU_TABLE, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA, tbl: null });
      this.cacheSystemTree({ type: EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC, tbl: null });
      this.cacheSystemTree({ type: EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_MULTIPLE_ECU_TABLE, tbl: null });
      this.cacheSystemTree({ type: config.EXECUE_FUNCTION_TYPE_MULTIPLE_ALL_CUSTOMIZE, tbl: null });
    }
  },

  mounted() {
    const isIdling = this.viewMode === config.PROCESS_IDLING;
    this.isTreeViewShow = isIdling;

    // ツリー押下時、(1)ツリーがない画面 (InformationMain 以外の画面) を経由して、(2)ツリーがある画面にリダイレクトさせるケースがある。
    // (2)のタイミングで isTreeViewOpen は初期化されてしまうので、キャッシュするようにする。
    // 誤動作防止のため、キャッシュの復元直後はクリアする。
    this.isTreeViewOpen = this.isCacheTreeViewOpen ? this.isCacheTreeViewOpen : false;
    // キャッシュ（isCacheTreeViewOpen）が存在すればクリアする
    if (this.isCacheTreeViewOpen) {
      this.cacheIsTreeViewOpen(false);
    }
  },
};
